var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6128 12.0012C11.6128 12.2369 11.7064 12.463 11.8731 12.6297C12.0398 12.7964 12.2659 12.8901 12.5017 12.8901C12.7374 12.8901 12.9635 12.7964 13.1302 12.6297C13.2969 12.463 13.3906 12.2369 13.3906 12.0012C13.3906 11.7654 13.2969 11.5394 13.1302 11.3727C12.9635 11.206 12.7374 11.1123 12.5017 11.1123C12.2659 11.1123 12.0398 11.206 11.8731 11.3727C11.7064 11.5394 11.6128 11.7654 11.6128 12.0012Z",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5015 7.55566C11.6226 7.55566 10.7635 7.81628 10.0327 8.30455C9.30199 8.79281 8.73244 9.48681 8.39611 10.2988C8.05979 11.1107 7.97179 12.0042 8.14325 12.8662C8.3147 13.7281 8.73792 14.5199 9.35936 15.1414C9.98081 15.7628 10.7726 16.186 11.6346 16.3575C12.4965 16.5289 13.39 16.4409 14.202 16.1046C15.0139 15.7683 15.7079 15.1987 16.1962 14.468C16.6845 13.7373 16.9451 12.8781 16.9451 11.9993",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3902 4.05183C11.7426 3.86698 10.0782 4.19871 8.6274 5.00113C7.17655 5.80355 6.0109 7.03699 5.29171 8.53085C4.57252 10.0247 4.33532 11.7051 4.61292 13.3397C4.89053 14.9742 5.66922 16.4821 6.84128 17.6548C8.01335 18.8274 9.52085 19.6069 11.1553 19.8853C12.7897 20.1638 14.4702 19.9274 15.9644 19.209C17.4587 18.4905 18.6927 17.3255 19.4958 15.8751C20.299 14.4246 20.6316 12.7604 20.4476 11.1127",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1677 6.66909V9.33525H17.8339L20.5 6.66909H17.8339V4.00293L15.1677 6.66909Z",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 9.33594L12.5022 12.0026",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.caddd71dddf2d581a6bebcec8a67dc4d.svg";
export { ForwardRef as ReactComponent };